import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ETutorialAudienceType } from "../../Enum/ETutorialAudienceType"
import { TutorialEntity } from "../../Objects/Tutorial/TutorialEntity"
import { GetRequest } from "../../services/ApiClientService"

const mapTutorials = (items: TutorialEntity[] | undefined) => (items ?? []).map((item) => new TutorialEntity(item))

export const useGetPublicTutorial = () => {
  const handleGetPublicTutorialByAudience = useCallback(async (audience: ETutorialAudienceType) => {
    const response = await GetRequest<TutorialEntity[]>(`${API_ROUTES.TUTORIAL.PUBLIC_GET_ALL}?audience=${audience}`)

    if (!response.success) {
      throw new Error(response.message || "Erro ao buscar tutoriais públicos.")
    }

    return mapTutorials(response.data)
  }, [])

  const handleGetPublicTutorialPreview = useCallback(async () => {
    const [storeTutorials, courierTutorials] = await Promise.all([
      handleGetPublicTutorialByAudience(ETutorialAudienceType.Store),
      handleGetPublicTutorialByAudience(ETutorialAudienceType.Courier),
    ])

    const uniqueTutorials = new Map<number, TutorialEntity>()

    ;[...storeTutorials, ...courierTutorials].forEach((item) => {
      if (item.id > 0) {
        uniqueTutorials.set(item.id, item)
      }
    })

    return Array.from(uniqueTutorials.values())
  }, [handleGetPublicTutorialByAudience])

  return { handleGetPublicTutorialByAudience, handleGetPublicTutorialPreview }
}
